export const ADD_CREDIT_CARD_MODAL = 'Add_CREDIT_CARD_MODAL';
export const ADD_CREDIT_CARD_AUTO_RENEW_MODAL =
  'ADD_CREDIT_CARD_AUTO_RENEW_MODAL';
